export enum DashboardMode {
  DELIVERY = 'delivery',
  CLEANING = 'cleaning',
}